module.exports = __webpack_public_path__ + "img/bedroom.7cc950dc.svg";